/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

require("jquery")
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import Inputmask from "inputmask";

require("corejs-typeahead");
import Bloodhound from 'corejs-typeahead'
window.Bloodhound = Bloodhound;

import Typeahead from 'corejs-typeahead'
window.Typeahead = Typeahead;

import Foundation from 'foundation-sites';

import Select2 from 'select2'
import Parsley from 'parsleyjs'
import {MaterialSelect, FileUpload} from 'materialize-css'

require("../file_upload")

import Uploaders from '../global_ui/uploaders';

document.addEventListener('DOMContentLoaded', () => {
  new Uploaders();
});

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

class MaterializedFoundation {
  constructor() {
    this.initFrameworks();
    this.initClickableBehaviors();
    this.initDelegatedMaterialBehaviors();
    this.initMaterialBehaviors();
    this.initGlobalNav();
    this.initValidationForms();

    this.snackbarQueue        = [];
    this.snackbarQueueRunning = false;

    if ($('#snackbars').length == 0) { $(document.body).append('<div id="snackbars" />'); }
  }

  initFrameworks() {
    $(document).foundation();
    $('[data-select2-enabled]').select2({placeholder: "Please select..."});
  }

  initGlobalNav() {
    $('.main-content-mask').hide();
    if ($('.global-left-nav').length >= 0) { new MaterializedFoundation.SideNav(); }
  }

  initDelegatedMaterialBehaviors() {
    $(document).on('click', '.chip i.close', function () { $(this).parent('.chip').remove(); });
    $(document).on('click', '.fab-buttons a.primary', (e) => {
      var el = $(e.currentTarget);

      if (el.hasClass('open')) {
        this.hideFabBar(el.parent('.fab-buttons'));
      } else {
        this.showFabBar(el.parent('.fab-buttons'));
      }
    });
    $(document).on('click', '.fab-buttons[data-close-on-click] ul li a', (e) => {
      setTimeout(() => {
        this.hideFabBar($(e.currentTarget).parents('.fab-buttons'));
      }, 100);
    });
  }

  initMaterialBehaviors() {
    $(window).on('changed.zf.mediaquery', (event, newSize, oldSize) => {
      Foundation.MediaQuery.atLeast('large') ? this.enableMaterialSelect() : this.disableMaterialSelect();
    });

    Foundation.MediaQuery.atLeast('large') ? this.enableMaterialSelect() : this.disableMaterialSelect();
  }

  showFabBar(el) {
    $(el).find('a.primary').addClass('open');
    $(el).find('ul').css('display', 'flex');
    setTimeout(() => { $(el).find('ul').addClass('expanded'); }, 10);
  }

  hideFabBar(el) {
    $(el).find('a.primary').removeClass('open');
    $(el).find('ul').removeClass('expanded');
    setTimeout(() => { $(el).find('ul').css('display', 'none'); }, 500);
  }

  initClickableBehaviors() {
    $(document).on('click', '[data-clickable]', function () {
      window.location.href = $(this).data('clickable-url');
    });
  }

  initValidationForms() {
    $('form[data-validation-forms]').each(function() {
      new ValidationForms(this);
    });
  }

  enableMaterialSelect() {
    $.each($('select[data-material-select]'), function (index, el) {
      $(el).removeClass('browser-default');
      $(el).next('label').removeClass('active');
      $(el).material_select();
    });
  }

  disableMaterialSelect() {
    $.each($('select[data-material-select]'), function (index, el) {
      $(el).material_select('destroy');
      $(el).addClass('browser-default');
      $(el).next('label').addClass('active');
    });
  }

  snackbar(message, opts) {
    var defaultOpts = { duration: 4000 };
    opts = {...defaultOpts, ...opts};
    this.snackbarQueue.push({ message: message, ...opts });
    this.runSnackbarQueue();
  }

  runSnackbarQueue() {
    if (this.snackbarQueueRunning == true || this.snackbarQueue.length == 0) { return; }
    this.snackbarQueueRunning = true;

    var snackbarComplete = function(component) {
      ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(component).parentNode);
      setTimeout(() => {
        this.snackbarQueueRunning = false;
        this.runSnackbarQueue();
      }, 500);
    }.bind(this);

    var snackbarItem = this.snackbarQueue.pop();
    ReactDOM.render(<MaterializedFoundation.Snackbar {...snackbarItem} onComplete={snackbarComplete} />, document.getElementById('snackbars'));
  }
}

MaterializedFoundation.SideNav = class MaterializedFoundationSideNav {
  constructor() {
    this.toggle            = $('.main-nav-toggle');
    this.overlay           = $('.main-content-mask');
    this.nav               = $('.global-left-nav');
    this.content_container = $('.main-content-container');
    this.nav_initial_left  = -this.nav.width() - 10;

    this.toggleSideNav = this.toggleSideNav.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    this.toggle.click(this.toggleSideNav);
    this.overlay.click(function(e) {
      e.preventDefault();

      if (this.navIsVisible()) {
        this.toggle.trigger('click');
      }
    }.bind(this));

    $(window).on('changed.zf.mediaquery', function(e, name) {
      if (name !== 'small' && this.navIsVisible()) {
        this.dismissSideNav();
      }
    }.bind(this));
  }

  navIsVisible() { return this.toggle.data('open') == 'yes'; }

  toggleSideNav(e) {
    e.preventDefault();

    if (this.navIsVisible()) {
      this.hideSideNav();
      this.toggle.data('open', 'no');
    } else {
      this.showSideNav();
      this.toggle.data('open', 'yes');
    }
  }

  showSideNav() {
    this.overlay.show();
    setTimeout(function() {
      this.overlay.css('opacity', 0.5);
      this.content_container.css({ overflow: 'hidden', height: '100vh' });
    }.bind(this), 0);
    setTimeout(function() { this.nav.css('left', 0); }.bind(this), 50);
  }

  hideSideNav() {
    this.overlay.css('opacity', 0);
    this.nav.css('left', this.nav_initial_left);
    this.content_container.css({ overflow: 'auto', height: '100%' });
    setTimeout(function () { this.overlay.hide(); }.bind(this), 150);
  }

  dismissSideNav() {
    this.overlay.hide().css('opacity', 0);
    this.nav.hide().css('left', this.nav_initial_left);
    setTimeout(function () { this.nav.show(); }.bind(this), 150);
    this.toggle.data('open', 'no');
  }
}

$(function() { window.MF = new MaterializedFoundation(); });

class ValidationForms {
  constructor (form) {
    this.form = $(form);
    this.serverAlert = this.form.find('.callout.alert');
    this.serverErrorListEl = this.serverAlert.find('ul.server-errors');
    this.initForm();
    this.bindParsley();
    this.bindEvents();
    this.bindMasks();
  }

  initForm() {
    this.form.attr('novalidate', true);
  }

  bindParsley() {
    this.form.parsley({ errorClass: 'invalid' })
      .on('field:error', (el) => {
        this.applyValidationStyles(el);
      });
    this.form.on('change', 'select', function (e) {
      $(this).parsley().validate();
    });
  }

  bindEvents() {
    this.form.on('ajax:before', (e) => {
      this.clearErrors();
    });

    this.form.on('ajax:beforeSend', (e, xhr, settings) => {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    });

    this.form.on('ajax:error', (e, xhr, status, error) => {
      this.displayErrorAlert();
      if (xhr.status == 422) {
        this.form.trigger('validation:serverErrors', [JSON.parse(xhr.responseText)]);
      }
      else if (xhr.status == 401) {
        this.form.trigger('validation:unauthorized')
      }
    });

    this.form.on('validation:unauthorized', (e) => {
      console.log("unauthorized");
      // TODO?
    });

    this.form.on('validation:serverErrors', (e, responseText) => {
      this.displayServerErrors(responseText);
    });
  }

  bindMasks() {
    Inputmask().mask(document.querySelectorAll("input[data-inputmask]"));
  }

  clearErrors() {
    this.serverErrorListEl.empty();
    this.serverAlert.addClass('hide');
  }

  displayErrorAlert() {
    this.serverAlert.removeClass('hide');
  }

  displayServerErrors(responseText) {
    $.each(responseText, function(key, value) {
      var message = `${key} ${value}`.humanize();
      this.serverErrorListEl.append(`<li>${message}</li>`);
    }.bind(this));
  }

  applyValidationStyles(parsleyEl) {
    var el = parsleyEl.$element
    var errors = el.next('.parsley-errors-list');
    var label = $(`label[for='${el.prop('id')}']`);

    if (errors.length != 0) {
      label.attr('data-error', errors.find('li').text());
      errors.remove();
    }
    label.addClass('active');
  }
}
